import { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "./api";

const StoreCtx = createContext(null);

export function StoreProvider({ children }) {
  const { slug } = useParams();
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    api.get(`/store/${slug}`)
      .then(({ data }) => {
        setTenant(data);
        applyTheme(data.branding || {});
      })
      .catch((e) => setError(e?.response?.data?.detail || "Tenant not found"))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <StoreCtx.Provider value={{ slug, tenant, loading, error, refresh: () => {
      api.get(`/store/${slug}`).then(({ data }) => { setTenant(data); applyTheme(data.branding || {}); });
    } }}>
      {children}
    </StoreCtx.Provider>
  );
}

export const useStore = () => useContext(StoreCtx);

function applyTheme(b) {
  const root = document.documentElement;
  root.style.setProperty("--t-primary", b.primary_color || "#0284C7");
  root.style.setProperty("--t-secondary", b.secondary_color || "#0369A1");
  root.style.setProperty("--t-accent", b.accent_color || "#38BDF8");
  root.style.setProperty("--t-bg", b.bg_color || "#F0F9FF");
  root.style.setProperty("--t-text", b.text_color || "#0C4A6E");
  root.style.setProperty("--t-surface", "#FFFFFF");
  root.style.setProperty("--t-heading-font", `"${b.heading_font || "Outfit"}"`);
  root.style.setProperty("--t-body-font", `"${b.body_font || "Nunito"}"`);
  // PWA: update theme-color and apple-touch-icon dynamically
  try {
    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", b.primary_color || "#0F172A");
    if (b.logo_url) {
      let icon = document.querySelector('link[rel="apple-touch-icon"]');
      if (!icon) {
        icon = document.createElement("link");
        icon.rel = "apple-touch-icon";
        document.head.appendChild(icon);
      }
      icon.setAttribute("href", b.logo_url);
    }
  } catch { /* ignore */ }
}
